import { useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import useCrypto from "../common/useCrypto";
import { useNavigate } from "react-router-dom";
import useFirestore from "../common/useFirestore";
import useFirebaseAuth from "../common/useFirebaseAuth";
import useStorage from "../common/useStorage";

function useInquiry(){
    const navigate = useNavigate();
    const uid = sessionStorage.getItem("uid");
    const {encrypto} = useCrypto();
    const [showSucceedModal, setShowSucceedModal] = useState(false);
    const {anonymousLogin} = useFirebaseAuth();
    const {uploadStorage} = useStorage();
    const { writeFirestore } = useFirestore();
    const [targetFileName, setTargetFileName] = useState("");
    const [progress, setProgress] = useState(0);
    const [showLoading, setShowLoading] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [inputs, setInputs] = useState({
        password:"",
        category:"기타",
        email:"",
        content:"",
        isSecret:false,
    })

    const handleChange = (file) => {
        setFileList(prev => [...prev, file]);
    };

    const onChange = (e) => {
        const {name, value} = e.target;
        if(name === "isSecret"){
            setInputs({
                ...inputs,
                [name]:e.target.checked
            })
            return;
        }
        setInputs({
            ...inputs,
            [name]:value
        })
    }

    const onSubmitClick = async() => {
        const login_state = await anonymousLogin();
        if(!login_state){
            return;
        }
        const document_id = uuidv4();
        setShowLoading(true);
        const file_url_list = await uploadFileList(document_id);
        setShowLoading(false);
        const encrypted_password = encrypto(inputs.password);
        const data = {
            file_list:file_url_list,
            password:encrypted_password,
            content:inputs.content,
            register_at:new Date(),
            isSecret:inputs.isSecret,
            category:inputs.category,
            uid:uid || "anonymous",
        }
        writeFirestore("/Inquiry", document_id, data).then(res => {
            if(res){
                setShowSucceedModal(true);
            }
        }).catch(err => {
            console.log(err);
        });
    }

    const uploadFileList = async(document_id) => {
        const file_url_list = [];
        for(let i = 0; i < fileList.length; i++){
            setTargetFileName(fileList[i].name)
            const url = await uploadStorage(document_id, fileList[i], setProgress).then(res => {
                return res;
            })
            file_url_list.push(url);
        }
        return file_url_list;
    }

    const onSucceedModalConfirmHandler = () => {
        setShowSucceedModal(false);
        navigate("/board");
    }

    return {fileList, handleChange, inputs, onChange, onSubmitClick, targetFileName, progress, showLoading, showSucceedModal, onSucceedModalConfirmHandler};
}

export default useInquiry;